import { Types } from './types'

const initialState = {
    statisticDashboard: {
    },
    order_tracking:{
        total_order: 0
    },
    buyer_tracking:{
        total_buyer: 0
    },
    gmv_tracking: {
        total_gmv: 0
    },
    cashback_tracking:{
        total_cashback: 0
    },
    token_tracking: {
        total_token: []
    },
    wallet_money: [],
    wallet_token: [],
    withdraw_token: [],
    withdraw_token_value: {
        allCoins: []
    },
    dataUserDAU: {},
    dataTotalUserDAU: {},
    historyRootAccount: {
        rows: [],
        total: 0

    },
    dataDailyBonus: []
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_DASHBOARD_DATA:
            return {
                ...newState,
                statisticDashboard: action.payload
            }
        case Types.SAVE_DASHBOARD_HISTORY_DATA:
            return {
                ...newState,
                historyRootAccount: action.payload
            }
        case Types.SAVE_ORDER_TRACKING:
            return {
                ...newState,
                order_tracking: action.payload
            }
        case Types.SAVE_BUYER_TRACKING:
            return {
                ...newState,
                buyer_tracking: action.payload
            }
        case Types.SAVE_GMV_TRACKING:
            return {
                ...newState,
                gmv_tracking: action.payload
            }
        case Types.SAVE_CASHBACK_TRACKING:
            return {
                ...newState,
                cashback_tracking: action.payload
            }
        case Types.SAVE_TOKEN_TRACKING:
            return {
                ...newState,
                token_tracking: action.payload
            }
        case Types.SAVE_WALLET_MONEY:
            return {
                ...newState,
                wallet_money: action.payload
            }
        case Types.SAVE_WALLET_TOKEN:
            return {
                ...newState,
                wallet_token: action.payload
            }
        case Types.SAVE_WITHDRAW_TOKEN:
            return {
                ...newState,
                withdraw_token: action.payload
            }
        case Types.SAVE_WITHDRAW_TOKEN_VALUE:
            return {
                ...newState,
                withdraw_token_value: action.payload
            }
        case Types.SAVE_USER_DAU:
            return {
                ...newState,
                dataUserDAU: action.payload
            }
        case Types.SAVE_TOTAL_USER_DAU:
            return {
                ...newState,
                dataTotalUserDAU: action.payload
            }
        case Types.SAVE_USER_DAILY:
            return {
                ...newState,
                dataDailyBonus: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
